import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { LayoutComponent } from './layouts/layout/layout.component';
import { AuthService } from './_services/auth.service';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HeaderComponent } from './layouts/header/header.component';
import { HttpAPIInterceptor } from './_core/interceptors/http-api.interceptor';
import { FooterComponent } from './layouts/footer/footer.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { UnauthorizeComponent } from './layouts/unauthorize/unauthorize.component';
import { AuthModule } from './modules/auth/auth.module';
import { ConfigurationLayoutComponent } from './layouts/configuration-layout/configuration-layout.component';
import { LoginModule } from './modules/auth/login/login.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';
import { AgmCoreModule } from '@agm/core';
import { environment } from 'src/environments/environment';
import { NewMemberComponent } from './layouts/newMember/newMember.component'

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    UnauthorizeComponent,
    ConfigurationLayoutComponent,
    NewMemberComponent
  ],
  imports: [
    DragDropModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgSelectModule,
    AppRoutingModule,
    ToastrModule.forRoot({ positionClass: 'toast-top-right', closeButton: true, timeOut: 6000 }), //Display toaster at top right position with close icon
    AuthModule,
    LoginModule,
    DashboardModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapsApiKey,
      libraries: ['places']
    })
  ],
  providers: [
    AuthService, 
    GoogleAnalyticsService,
    ToastrService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: HttpAPIInterceptor, multi: true },
    { provide: 'Window', useValue: window }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
